<div class="month-navigation">
  <button
    mat-icon-button
    class="month-nav-button"
    type="button"
    [disabled]="!can_go_to_previous_month()"
    (click)="onPreviousMonthClick()"
    [matTooltip]="previous_month_label()"
    matTooltipPosition="below"
    aria-label="Ir al mes anterior"
  >
    <mat-icon class="month-nav-icon">chevron_left</mat-icon>
  </button>
  <span class="month-current-label">
    {{ selected_month_label() }}
  </span>
  <button
    mat-icon-button
    class="month-nav-button"
    type="button"
    [disabled]="!can_go_to_next_month()"
    (click)="onNextMonthClick()"
    [matTooltip]="next_month_label()"
    matTooltipPosition="below"
    aria-label="Ir al mes siguiente"
  >
    <mat-icon class="month-nav-icon">chevron_right</mat-icon>
  </button>
  <button
    mat-icon-button
    class="month-current-button"
    type="button"
    [disabled]="!can_go_to_current_month()"
    (click)="onCurrentMonthClick()"
    [matTooltip]="current_button_tooltip()"
    matTooltipPosition="below"
    aria-label="Ir al periodo actual"
  >
    <mat-icon>today</mat-icon>
  </button>
</div>
